import { produce } from 'immer';

import * as Types from './types';
import { actionTypes } from './constants';

export const defaultState: Types.IPageState = {
    path: '',
    siteName: '',
    isPageRendered: false,
    isPageRendering: true,
    popupBackgroundPagePath: '',
    dynamicPagePath: '',
    description: '',
    error: '',
    footer: '',
    friendlyURL: '',
    headerWcId: '',
    hidePopUpTitle: null,
    isShowAsModal: false,
    keywords: '',
    layoutDynamicConfig: {
        backgroundConfiguration: {
            backgroundColor: '',
            backgroundFixed: false,
            backgroundImage: ''
        },
        canonicalTagConfiguration: {
            customUrl: '',
            isDisabled: false,
            layout: '',
            useLayout: false,
            localeToUrl: {}
        }
    },
    menuWcId: '',
    name: '',
    overrideFooter: false,
    overrideHeader: true,
    overrideMenu: true,
    pageLayoutId: '',
    permissions: {
        guest: false,
        user: false
    },
    popupWidth: 0,
    popupWidthUnit: '',
    portlets: [],
    robots: '',
    rootClassNames: '',
    showAsPopUp: false,
    success: false,
    title: '',
    translations: {},
    url: {},
    pageLayout: {
        id: '',
        name: '',
        layoutClasses: '',
        layoutWidth: '',
        layouts: []
    }
};

export const reducer = produce((draftState, action: Types.TPageAction): Types.IPageState | void => {
    switch (action.type) {
        case actionTypes.PAGE_DATA_SET: {
            Object.assign(draftState, {
                ...action.payload.page,
                path: action.payload.path,
                dynamicPagePath: ''
            });

            break;
        }
        case actionTypes.PAGE_POPUP_BG_PAGE_PATH_SET: {
            Object.assign(draftState, {
                popupBackgroundPagePath: action.payload
            });

            break;
        }

        case actionTypes.PAGE_DYNAMIC_PAGE_PATH_SET: {
            Object.assign(draftState, {
                dynamicPagePath: action.payload
            });

            break;
        }

        case actionTypes.PAGE_RENDERING_TOGGLE: {
            Object.assign(draftState, {
                isPageRendering: action.payload
            });

            break;
        }

        case actionTypes.PAGE_RENDERED_TOGGLE: {
            Object.assign(draftState, {
                isPageRendered: action.payload
            });

            break;
        }

        default: {
            break;
        }
    }
}, defaultState);
